module.exports = __webpack_public_path__ + "img/link_icon.bd5c498f.svg";